/* unplugin-vue-components disabled */import { render } from "./list.vue?vue&type=template&id=6eab0e28&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=6eab0e28&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eab0e28"]])

export default __exports__